import { DeleteOutlined, EditOutlined, PlusOutlined, FilterOutlined } from '@ant-design/icons';
import { Button, Dropdown, Flex, Input, Modal, Space, Table, Select, Image, Typography } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';

import new_category_Api from '../../api/new-category';
import newApi from '../../api/new';
import SH_Toolbar from '../../components/SH_Toolbar';
import TV_news_detail from './TV_news_detail';
import projectApi from '../../api/project';

const { Title } = Typography;

const SH_news = () => {
	const [dictionary, setDictionary] = useState({ categories: [], projects: [] });
	const [products, setProducts] = useState([]);
	const [loading, setLoading] = useState(false);
	const [total, setTotal] = useState(0);
	const refDetail = useRef();

	const [filter, setFilter] = useState({
		page: 1,
		limit: 10,
		search: '',
	});

	useEffect(() => {
		getProducts();
		getCategory().then((r) => r);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getCategory = async () => {
		setLoading(true);
		try {
			const [categories, projects] = await Promise.all([
				new_category_Api.get({ page: 1, limit: 9999 }),
				projectApi.get({ page: 1, limit: 9999 }),
			]);

			setDictionary({
				categories: categories?.data?.data?.items?.map((x) => ({ ...x, label: x?.names?.vi })) || [],
				projects: projects?.data?.data?.items?.map((x) => ({ ...x, label: x?.names?.vi })) || [],
			});
		} finally {
			setLoading(false);
		}
	};

	const getProducts = (_filter = filter) => {
		setLoading(true);
		newApi
			.get({
				..._filter,
				limit: _filter?.limit || 10,
				page: _filter?.page || 1,
			})
			.then((res) => {
				setProducts(res?.data?.data?.items || []);
				setTotal(res?.data?.data?.pagination?.total || 0);
				setLoading(false);
			});
	};

	const conFirm = (event) => {
		return Modal.confirm({
			title: 'Xác nhận xóa',
			content: 'Bạn có chắc chắn muốn xóa bản ghi này không ? ',
			onOk: () => {
				deleteItem(event);
			},
			footer: (_, { OkBtn, CancelBtn }) => (
				<>
					<CancelBtn />
					<OkBtn />
				</>
			),
			okText: 'Xóa',
			cancelText: 'Hủy',
			okButtonProps: { danger: true },
		});
	};

	const deleteItem = (event) => {
		setLoading(true);
		newApi.delete(event._id).then(() => {
			setLoading(false);
			getProducts();
		});
	};

	const showModal = () => {
		refDetail.current.create();
	};

	const handlePageChange = (page, pageSize) => {
		setFilter((prevState) => ({ ...prevState, page, limit: pageSize }));
		getProducts({ ...filter, page, limit: pageSize });
	};

	const columns = [
		{
			title: 'Tên tin tức',
			dataIndex: 'names',
			key: 'names_vi',
			ellipsis: true,
			render: (text) => <span>{text?.vi}</span>,
		},
		// {
		// 	title: 'Tên tin tức (EN)',
		// 	dataIndex: 'names',
		// 	key: 'names_en',
		// 	ellipsis: true,
		// 	render: (text) => <span>{text?.en}</span>,
		// },
		{
			title: 'Loại tin tức',
			dataIndex: 'categoryList',
			key: 'categoryList',
			ellipsis: true,
			render: (categoryList) => categoryList?.map((x) => x?.names?.vi)?.join(', '),
		},
		{
			title: 'Ảnh',
			dataIndex: 'images',
			key: 'images',
			width: 120,
			render: (images) =>
				images?.url ? (
					<Image
						width={90}
						height={60}
						style={{ objectFit: 'cover', borderRadius: 10 }}
						src={images.url}
						alt=""
					/>
				) : (
					<span>-</span>
				),
		},
		{
			title: 'Ngày tạo',
			dataIndex: 'createdAtDate',
			key: 'createdAtDate',
			width: 190,
			render: (createdAtDate) => (
				<span>{createdAtDate ? dayjs(createdAtDate).format('HH:mm A DD/MM/YYYY') : ''}</span>
			),
			sorter: (a, b) => dayjs(a.createdAtDate).valueOf() - dayjs(b.createdAtDate).valueOf(),
			sortDirections: ['descend', 'ascend'],
		},
		{
			title: 'Thao tác',
			key: 'action',
			width: 190,
			render: (_, record) => (
				<Space size="middle">
					<Button onClick={() => refDetail.current.update(record)} icon={<EditOutlined />}>
						Sửa
					</Button>
					<Button onClick={() => conFirm(record)} type="dashed" danger icon={<DeleteOutlined />}>
						Xoá
					</Button>
				</Space>
			),
		},
	];

	return (
		<>
			<Flex
				align="center"
				justify="space-between"
				wrap="wrap"
				gap={12}
				style={{
					marginBottom: 12,
				}}
			>
				<Title level={2} style={{ margin: 0 }}>
					Tin tức
				</Title>
			</Flex>

			<SH_Toolbar
				left={() => (
					<Button icon={<PlusOutlined />} type="primary" onClick={showModal}>
						Thêm tin tức
					</Button>
				)}
				right={() => (
					<Flex gap={8} wrap="wrap" align="center">
						<Input.Search
							allowClear
							style={{ width: 260 }}
							placeholder="Nhập tên tin tức"
							onChange={(e) => {
								getProducts({ ...filter, search: e.target.value });
								setFilter((prevState) => ({ ...prevState, search: e.target.value }));
							}}
						/>

						<Dropdown
							trigger={['click']}
							placement="bottomRight"
							dropdownRender={() => (
								<div style={{ width: 320, background: '#fff', padding: 12, borderRadius: 12 }}>
									<Space direction="vertical" size={12} style={{ width: '100%' }}>
										<div>
											<div style={{ fontWeight: 600, marginBottom: 6 }}>Dự án</div>
											<Select
												allowClear
												style={{ width: '100%' }}
												value={filter.projectId}
												fieldNames={{ label: 'label', value: '_id' }}
												options={dictionary?.projects}
												placeholder="Chọn dự án"
												onChange={(e) => {
													getProducts({ ...filter, projectId: e });
													setFilter((prevState) => ({ ...prevState, projectId: e }));
												}}
											/>
										</div>

										<div>
											<div style={{ fontWeight: 600, marginBottom: 6 }}>Loại tin tức</div>
											<Select
												mode="multiple"
												allowClear
												style={{ width: '100%' }}
												fieldNames={{ label: 'label', value: '_id' }}
												value={filter.categories}
												options={dictionary?.categories}
												placeholder="Chọn loại tin tức"
												onChange={(e) => {
													getProducts({ ...filter, categories: e });
													setFilter((prevState) => ({ ...prevState, categories: e }));
												}}
											/>
										</div>
									</Space>
								</div>
							)}
						>
							<Button icon={<FilterOutlined />}>Lọc</Button>
						</Dropdown>
					</Flex>
				)}
			/>

			<Table
				rowKey={(record) => record?._id}
				pagination={{
					current: filter.page,
					pageSize: filter.limit,
					total: total,
					onChange: handlePageChange,
					showSizeChanger: true,
				}}
				className="mt-2"
				loading={loading}
				columns={columns}
				dataSource={products}
				scroll={{ x: 1300 }}
			/>

			<TV_news_detail
				ref={refDetail}
				getProducts={getProducts}
				categories={dictionary?.categories}
				projects={dictionary?.projects}
			/>
		</>
	);
};

export default SH_news;
